import { CandidateProfileDetails } from 'modules/candidate-profile/types/CandidateProfileDetails';
import {
  CandidateProfileDetailProps,
  CandidateProfileDetailType
} from 'modules/candidate-profile/types/CandidateProfileDetailProps';
import { RouterLink } from 'common/ui/RouterLink';
import { Launch } from '@mui/icons-material';
import { Button } from 'system/atoms';
import { formatAtsProviderName } from 'core/utils/formatAtsProviderName';

type GetCandidateProfileActionItemsProps = {
  candidateProfileDetailProps: CandidateProfileDetailProps;
  candidateProfile: CandidateProfileDetails;
  provider: string | null | undefined;
  atsCandidateUrl: string | null | undefined;
  isSelected: boolean;
  isInviteToApplyHidden: boolean;
  onInviteToggle: () => void;
  onAddToTalentList: () => void;
};

const linkStyle: React.CSSProperties = {
  textDecoration: 'none',
  display: 'flex',
  alignItems: 'center'
};

export const getCandidateProfileActionItems = ({
  candidateProfileDetailProps,
  candidateProfile,
  atsCandidateUrl,
  provider,
  isSelected,
  isInviteToApplyHidden,
  onInviteToggle,
  onAddToTalentList
}: GetCandidateProfileActionItemsProps): React.ReactNode[] => {
  const items: React.ReactNode[] = [];

  if (atsCandidateUrl && provider) {
    items.push(
      <RouterLink
        key="view-in-ats"
        to={atsCandidateUrl}
        target="_blank"
        style={linkStyle}
      >
        <Button variant="tertiary">
          View in {formatAtsProviderName(provider)} <Launch />
        </Button>
      </RouterLink>
    );
  }

  if (candidateProfile.linkedInProfileUrl) {
    items.push(
      <RouterLink
        key="linkedin"
        to={candidateProfile.linkedInProfileUrl}
        target="_blank"
        style={linkStyle}
      >
        <Button variant="tertiary">
          LinkedIn profile <Launch />
        </Button>
      </RouterLink>
    );
  }

  const showAddToTalentList =
    candidateProfileDetailProps.type ===
      CandidateProfileDetailType.CANDIDATE_PROFILE_DETAILS ||
    candidateProfileDetailProps.type ===
      CandidateProfileDetailType.TALENT_POOL_ADD_CANDIDATES_CANDIDATE_PROFILE_DETAILS;

  const showInviteToApply =
    !isInviteToApplyHidden &&
    candidateProfileDetailProps.type !==
      CandidateProfileDetailType.TALENT_POOL_ADD_CANDIDATES_CANDIDATE_PROFILE_DETAILS;

  if (showAddToTalentList) {
    items.push(
      <Button
        key="add-to-talent-list"
        variant="secondary"
        onClick={onAddToTalentList}
      >
        Add to talent list
      </Button>
    );
  }

  if (showInviteToApply) {
    items.push(
      <Button
        key="invite-to-apply"
        variant={isSelected ? 'secondary' : 'primary'}
        onClick={onInviteToggle}
      >
        {isSelected ? 'Remove from invite' : 'Invite to apply'}
      </Button>
    );
  }

  return items;
};
